module.exports = __webpack_public_path__ + "assets/img/load.d7d0b8af.gif";